import React from 'react';
import { Field, useFormikContext } from 'formik';
import { FormattedMessage } from 'react-intl';
import { DropdownComponent } from '../../../../../components/prime-formik';

const SuperProfileJobSeniorityRelevanceInput = () => {
  const { setFieldValue } = useFormikContext();

  const jobSeniorityRelevanceOptions = [
    { label: 'Not required', value: 'NOT_REQUIRED' },
    { label: 'Must be partly job relevant', value: 'MUST_BE_PARTLY_JOB_RELEVANT' },
    { label: 'Must be job relevant', value: 'MUST_BE_JOB_RELEVANT' },
  ];

  return (
    <div className="p-col-12">
      <div className="flex-space-between">
        <FormattedMessage
          id="account.super-profiles.new.job-seniority-relevance"
          defaultMessage="Job seniority/experience relevance"
        >
          {(text) => (
            <label className="field-label" htmlFor="jobSeniorityRelevance">
              {text}
            </label>
          )}
        </FormattedMessage>
        <FormattedMessage id="select" defaultMessage="Select">
          {(text) => (
            <Field
              id="jobSeniorityRelevance"
              name="jobSeniorityRelevance"
              component={DropdownComponent}
              options={jobSeniorityRelevanceOptions}
              filter
              filterBy="label,value"
              className="right"
              onChange={(event) => {
                setFieldValue('jobSeniorityRelevance', event.value);
              }}
              placeholder={`-- ${text} --`}
            />
          )}
        </FormattedMessage>
      </div>
    </div>
  );
};

export default SuperProfileJobSeniorityRelevanceInput;
